import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { IModalAction } from 'models/modal';
import { Modal, Button, WhiteButton } from 'components';
import { IUserLanguage } from 'models/user/userlanguage';
import { ILanguage } from 'models/common';
import { IStore } from 'redux/IStore';
import { deactivateAccount } from 'redux/modules/user/userprofile';
import { IUserProfileAction } from 'models/user/userprofile';
import { PortalCheckboxField } from 'components/FormControls';
const { connect } = require('react-redux');

interface IProps {
	userLanguage?: IUserLanguage;
	languageDomainValues?: ILanguage[];
	showHeaderCloseButton?: boolean;
	baseUrlClient?: string;
	step?: number;

	t?: (key: string) => string;
	closeModal?: () => IModalAction;
	deactivateAccount?: (redirectUrl: string) => IUserProfileAction;
}

interface IState {
	currentStep: number;
	testValue: string;
}

@connect(
	(state: IStore) => ({
		cart: state.cart,
		languageDomainValues: state.domainValues.languages,
		userLanguage: state.userLanguage,
	}),
	(dispatch) => ({
		deactivateAccount: (redirectUrl: string) => dispatch(deactivateAccount(redirectUrl)),
		dispatch,
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class DeactivateUser extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		if (props.step > 0) {
			this.state = {
				currentStep: props.step,
				testValue: '0',
			};
		} else {
			this.state = {
				currentStep: 1,
				testValue: '0',
			};
		}

		this.nextStep = this.nextStep.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.deactivateAccount = this.deactivateAccount.bind(this);
		this.onTestClick = this.onTestClick.bind(this);
	}

	public onTestClick(value: string) {
		this.setState({ testValue: value });
	}

	public nextStep() {
		this.setState({ currentStep: this.state.currentStep + 1 });
	}

	public deactivateAccount() {
		const culture = this.props.userLanguage.culture;
		const homeLink = 'home/' + culture.substring(0, 2);
		const redirectUrl: string = '/deactivateuser?returnUrl=' + homeLink;
		this.props.deactivateAccount(redirectUrl);
	}

	private renderStepContent(step: number): JSX.Element {
		if (step === 1) {
			return (
				<div className="deactivateUser">
					<div className="bodyWrapper">
						<p className="bodyText">{this.props.t('User_Deactivate_Title_ExplainDeactivate')}</p>
					</div>
				</div>
			);
		} else if (step === 2) {
			return (
				<div className="deactivateUser">
					<div className="bodyWrapper">
						<p className="bodyText">{this.props.t('User_Deactivate_Title_TellUsWhy_Explain')}</p>
					</div>
					<ul>
						<PortalCheckboxField
							usage="portal"
							type="checkbox"
							input={{
								checked: this.state.testValue === '0',
								onChange: () => this.onTestClick('0'),
							}}
							label={this.props.t('User_Deactivate_Title_Reason1')}
						/>
						<PortalCheckboxField
							usage="portal"
							type="checkbox"
							input={{
								checked: this.state.testValue === '1',
								onChange: () => this.onTestClick('1'),
							}}
							label={this.props.t('User_Deactivate_Title_Reason2')}
						/>
						<PortalCheckboxField
							usage="portal"
							type="checkbox"
							input={{
								checked: this.state.testValue === '2',
								onChange: () => this.onTestClick('2'),
							}}
							label={this.props.t('User_Deactivate_Title_Reason3')}
						/>
						<PortalCheckboxField
							usage="portal"
							type="checkbox"
							input={{
								checked: this.state.testValue === '3',
								onChange: () => this.onTestClick('3'),
							}}
							label={this.props.t('User_Deactivate_Title_Reason4')}
						/>
					</ul>
				</div>
			);
		} else if (step === 3) {
			return (
				<div className="deactivateUser">
					<div className="bodyWrapper">
						<p className="bodyText">{this.props.t('User_Deactivate_Title_WeWillMissYou_Explain')}</p>
					</div>
				</div>
			);
		}
	}

	private closeModal() {
		this.props.closeModal();
	}

	public render() {
		const { t } = this.props;
		const { currentStep } = this.state;

		const footer = () => {
			if (currentStep === 1) {
				return (
					<div className="bottomButtons">
						<WhiteButton type="button" onClick={this.closeModal}>
							{this.props.t('BSPortal_Common_Cancel')}
						</WhiteButton>
						<Button type="button" onClick={this.nextStep}>
							{this.props.t('BSPortal_Common_Next')}
						</Button>
					</div>
				);
			} else if (currentStep === 2) {
				return (
					<div className="bottomButtons">
						<WhiteButton type="button" onClick={this.closeModal}>
							{this.props.t('BSPortal_Common_Cancel')}
						</WhiteButton>
						<Button type="button" onClick={this.deactivateAccount}>
							{this.props.t('User_Deactivate_DeactivateMyAccount')}
						</Button>
					</div>
				);
			} else if (currentStep === 3) {
				return (
					<div className="bottomButtons">
						<Button type="button" onClick={this.closeModal}>
							{' '}
							{this.props.t('BSPortal_Common_Close')}{' '}
						</Button>
					</div>
				);
			}
		};

		return (
			<div className="deactivateUserComponent">
				<Modal
					title={
						currentStep === 1
							? t('User_Deactivate_Title_AreYouSure')
							: currentStep === 2
							  ? t('User_Deactivate_Title_TellUsWhy')
							  : currentStep === 3
							    ? t('User_Deactivate_Title_WeWillMissYou')
							    : t('User_Deactivate_Title_AreYouSure')
					}
					showHeaderCloseButton={true}
					closeModal={this.closeModal}
					size={'small'}
					modalClass="modalDeactivateAccWrapper"
					footer={footer()}
				>
					{this.renderStepContent(currentStep)}
				</Modal>
			</div>
		);
	}
}

export { DeactivateUser };
